import { render, staticRenderFns } from "./UserListTaxData.vue?vue&type=template&id=609214d1&"
import script from "./UserListTaxData.vue?vue&type=script&lang=js&"
export * from "./UserListTaxData.vue?vue&type=script&lang=js&"
import style0 from "./UserListTaxData.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports